import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronUpIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 7.18L19.36 14.54L17.88 16.02L12 10.14L6.12 16.02L4.64 14.54L12 7.18Z" />
    </SvgIcon>
  );
});
